<i class="far {{iconClassCollapsed}}"
   (click)="toggle()"
   *ngIf="isCollapsed"
   [class.toggle-enabled]="isEnabled"
   [class.toggle-disabled]="!isEnabled"
   [matTooltip]="tooltipCollapsed"
   matTooltipClass="pop-tooltip"
   position="below"></i>

<i class="far {{ iconClassExpanded }}"
   (click)="toggle()"
   *ngIf="!isCollapsed"
   [class.toggle-enabled]="isEnabled"
   [class.toggle-disabled]="!isEnabled"
   [matTooltip]="tooltipExpanded"
   matTooltipClass="pop-tooltip"
   position="below"></i>

<ng-content></ng-content>
